<template>
		<div class="content wrap-page">
		<Header></Header>
			<div class="info crfff" style="padding: 0;">
        <div class="back" @click="back" style="padding: 0 30px;">
          <img width="70" src="../../static/images/back.png" />
          <span class="fs50 w-title ac">{{$t('RankingChallenge')}}</span>
        </div>
        <div class="ac mt30">
          <img src="../../static/images/paiwei-img.png"/>
        </div>
        <div class="rank-list mt30" style="padding: 0 30px;">
          <div class="">
            <div class="li por" v-for="(item,index) in redeemList" @click="goPaiewi(item)">
              <img v-if="!item.can_play" class="lock" src="../../static/images/lock.png">
              <div class="btn-purple li-t disflex">
                <img style="width: 160px; height: 160px;border-radius: 100%" :src="item.image" />
                <div style="width: 70%;">
                  <div class="" :class="'lf'+index">
                    <div class="disflex">
                      <div class="">
                        <div class="title">{{$t('Title')}}: {{item.title}}</div>
                        <div class="prz">{{$t('RequireLevel')}}: {{item.need_level}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="disflex">
                    <div class="disflex">
                      <div class="btn-yellow" style="background: linear-gradient(to bottom,#fd851a,#ffb210);border:none;box-shadow: 0 5px 10px inset #fff;"><span style="padding: 5px 10px;display: inline-block;">{{$t('Bouns')}}<img width="40" class="ml10" src="../../static/images/point-2.png">{{item.reward_points}}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        redeemList:[]
      }
    },
	created(){
    this.getRedeem()
	},
  methods: {
		back(){
			this.$router.go(-1);
      // this.$router.push({path:'/land',query: {msisdn:this.$route.query.mobile}});
		},
    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/rank_challenge/list',null,r =>{
        that.redeemList = r.data
        that.$parent.loadModal(false);
      })
    },
    goPaiewi(item){
      if(!item.can_play){
        return;
      }
      this.$router.push({path:'/paiwei',query: {id:item.id,reward_points:item.reward_points,need_level:item.need_level}});
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/rankingChallenge.vue